import api from '../api';
const baseUrl = process.env.REACT_APP_AUTH_API_URL;

const publishDeliverable = async (projectId, payload, keycloakToken) => {
    try {
        const response = await api.post(`${baseUrl}/publishables/${projectId}`, payload, {
            headers: {
                'Authorization': `Bearer ${keycloakToken}`,
                'Content-Type': 'application/json',
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error to publish deliverable", error);
        throw new Error(error?.response?.data?.message || "Erro ao publicar entregável");
    }
}

export default { publishDeliverable };